module.exports = __webpack_public_path__ + "img/question.300ea57e.svg";